module.exports = __webpack_public_path__ + "static/media/count.8c56f8fd.png";